/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerReprocessRunActionsMutationResponse, AuditReportsTriggerReprocessRunActionsPathParams, AuditReportsTriggerReprocessRunActions400, AuditReportsTriggerReprocessRunActions401, AuditReportsTriggerReprocessRunActions403, AuditReportsTriggerReprocessRunActions404 } from "../models/AuditReportsTriggerReprocessRunActions";

export function getAuditReportsTriggerReprocessRunActionsUrl(id: AuditReportsTriggerReprocessRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/aod-runs/${id}/reprocess` as const }
  return res
}

/**
 * @description Triggers a reprocess of the order associated with a run using the Olaf API
 * @summary Trigger Olaf reprocess for a run
 * {@link /audit-reports/v1/aod-runs/:id/reprocess}
 */
export async function auditReportsTriggerReprocessRunActions(id: AuditReportsTriggerReprocessRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsTriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessRunActions400 | AuditReportsTriggerReprocessRunActions401 | AuditReportsTriggerReprocessRunActions403 | AuditReportsTriggerReprocessRunActions404>, unknown>({ method : "PUT", url : getAuditReportsTriggerReprocessRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}